import { render, staticRenderFns } from "./MenuItems.vue?vue&type=template&id=11b32508&scoped=true"
import script from "./MenuItems.vue?vue&type=script&lang=js"
export * from "./MenuItems.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=11b32508&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b32508",
  null
  
)

export default component.exports